export default "__VITE_ASSET__B60BWWNl__ 768w, __VITE_ASSET__CMl$PKBX__ 1280w, __VITE_ASSET__BZtmj5cA__ 2048w";